<template>
  <div>
    <b-avatar
        button
        variant="secondary"
        :src="valueUrl"
        size="72px"
        :disabled="disabled"
        @click="browseFile"
        class="me-3"
    ></b-avatar>
    <a v-if="value" href="" @click.prevent="removeFile" class="fw-bold">{{ $t('Delete') }}</a>
    <input :disabled="disabled" :name="name" ref="file" style="visibility: hidden" type="file" accept="image/*" @change="onChangeFile"/>
  </div>
</template>

<script>
import imageCompression from "browser-image-compression";

export default {
  model: {
    event: 'change'
  },
  props: {
    name: {
      type: String, default() { return ''; }
    },
    disabled: {type: Boolean, default: false},
    value: {
      type: [String, File, Blob],
      default: undefined
    }
  },
  data() {
    return {
      rawValue: this.value
    }
  },
  computed: {
    valueUrl: function () {
      return (this.value instanceof Blob) ? URL.createObjectURL(this.value) : this.value;
    }
  },
  watch: {
    rawValue(value) {
      const file = value;
      if (!file) {
        this.$emit('change', file);
        return;
      }
      imageCompression(file, {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 1024,
        useWebWorker: false,
      }).then((result) => {
        this.$emit('change', result)
        return result;
      })
    }
  },
  methods: {
    browseFile() {
      this.$refs.file.click()
    },
    onChangeFile(event) {
      if (!event.target.files.length) return;
      this.rawValue = event.target.files[0];
    },
    removeFile(){
      this.rawValue = null;
    }
  }
}
</script>
